/* 请求方式的再封装，如果不希望对接口错误做定制处理，采用此种方式把错误toast即可 */
import domain from '@common/domain'
import ajax from '@finance/ajax-monitor'
import store from '$stores'
import toast from '@common/toast'

// if (process.env.API_DOMAIN === 'dev' || process.env.API_DOMAIN === 'mock') {
// //   domain.api = 'http://172.22.145.123:8080/app/mock'
// //   // domain.api = 'http://172.22.23.146:6111/mockjsdata'
// // }

let timeoutId
const resetTimeoutId = () => {
  if (!timeoutId) return
  clearTimeout(timeoutId)
  timeoutId = null
}

export default (url, body = {}, loading = true, isTost = true) => {
  resetTimeoutId()
  if (loading) {
    timeoutId = setTimeout(() => {
      store.commit('showLoading')
    }, 300)
  }
  return ajax.request({
    url: domain.api + url,
    body: { actCode: window.actCode, ...body }
  }).then((result) => {
    resetTimeoutId()
    store.commit('hideLoading')
    if (!result.succeed) {
      return Promise.reject(result)
    }
    return result.data
  }).catch((err) => {
    resetTimeoutId()
    store.commit('hideLoading')
    let msg = err
    if (typeof err === 'object') {
      msg = err.msg
    }
    if (isTost) toast(msg)
    return Promise.reject(err)
  })
}



// WEBPACK FOOTER //
// ./src/services/request.js